var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.094 512.094",
    height: 512,
    viewBox: "0 0 512.094 512.094",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.085 425.468c-2.215 1.108-4.626 1.661-7.038 1.661-2.411 0-4.823-.554-7.038-1.661l-187.143-93.572-53.166 26.583c-11.599 5.8-11.599 22.353 0 28.152l240.309 120.155c4.431 2.215 9.646 2.215 14.076 0l240.309-120.155c11.599-5.8 11.599-22.353 0-28.152l-53.166-26.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.085 308.959c-2.215 1.108-4.626 1.661-7.038 1.661-2.411 0-4.823-.554-7.038-1.661l-187.143-93.571-53.166 26.583c-11.599 5.8-11.599 22.353 0 28.152l247.347 123.674 247.347-123.674c11.599-5.8 11.599-22.353 0-28.152l-53.166-26.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.394 125.462-240.309-120.155c-4.431-2.215-9.646-2.215-14.076 0l-240.309 120.155c-11.599 5.8-11.599 22.353 0 28.152l247.347 123.674 247.347-123.674c11.6-5.799 11.6-22.352 0-28.152z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.6d2f4236d1ab125f769afb370965188c.svg";
export { ForwardRef as ReactComponent };